import { useTwoFaEnablingWizardContext } from 'modules/components';
import { hooks } from 'modules/page';
import { useCallback } from 'react';
import { routingService } from 'services/routing';
import { storageService } from 'services/storage';

const onWizardSuccess = () => {
    const params = new URLSearchParams(window.location.search);
    const redirectUrl = params.get('redirectUrl') || null;

    storageService.resetIsTwoFaHardEnforcement();

    if (redirectUrl) {
        window.location.href = redirectUrl;
    } else {
        routingService.reloadToDefaultPath();
    }
};

/**
 * @deprecated Old Design
 */
export const useTwoFaHardEnforcementPage = () => {
    const { showWizard } = useTwoFaEnablingWizardContext();
    const authenticated = hooks.useProtectedAuth();

    const onWizardStart = useCallback(() => {
        showWizard(onWizardSuccess);
    }, [showWizard]);

    return {
        onWizardStart,
        authenticated,
    };
};
